import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgmCoreModule, LAZY_MAPS_API_CONFIG } from '@agm/core';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleTagManager } from 'angulartics2/gtm';
import { LinkyModule } from 'angular-linky';
import 'hammerjs';

import { AppRoutingModule } from './routing/app-routing.module';
import { AppErrorHandler } from './app-error-handler/app-error-handler.service';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { AirportModule } from './airport/airport.module';
import { BusinessModule } from './business/business.module';
import { SharedModule } from './shared/shared.module';
import { AppMaterialModule } from './app-material.module';
import { SearchModule } from './search/search.module';
import { GoogleMapsConfig } from './google-maps-config.service';
import { EventModule } from './event/event.module';


@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    SharedModule,
    AppMaterialModule,
    AppRoutingModule,
    AuthModule,
    AgmCoreModule.forRoot(),
    AirportModule,
    BusinessModule,
    SearchModule,
    EventModule,
    Angulartics2Module.forRoot([Angulartics2GoogleTagManager]),
    LinkyModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: AppErrorHandler },
    { provide: LAZY_MAPS_API_CONFIG, useClass: GoogleMapsConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
